export type VetterApprovalStatusFilter = 'ACTIVE' | 'AWAITING';

export const checkAllValuesAreTruthy = (
  ...profileData: Array<string | boolean | null | undefined>
) => profileData.every(i => Boolean(i));

export const validImageFileTypes = new Set([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
]);

export const isValidImageFileType = (fileType: string) =>
  validImageFileTypes.has(fileType.toLowerCase());

export const VetterChannels = [
  {
    value: 'Search Engine',
    text: 'Search Engine',
  },
  {
    value: 'Advertising',
    text: 'Advertising',
  },
  {
    value: 'Social media',
    text: 'Social media',
  },
  {
    value: 'Word of mouth',
    text: 'Word of mouth',
  },
  {
    value: 'Conference',
    text: 'Conference',
  },
  {
    value: 'Existing Vetter',
    text: 'Existing Vetter',
  },
  {
    value: 'Other',
    text: 'Other',
  },
];
